// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Lazy = require("../Control.Lazy/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Text_Parsing_StringParser = require("../Text.Parsing.StringParser/index.js");
var Text_Parsing_StringParser_CodeUnits = require("../Text.Parsing.StringParser.CodeUnits/index.js");
var Text_Parsing_StringParser_Combinators = require("../Text.Parsing.StringParser.Combinators/index.js");
var HtmlAttribute = (function () {
    function HtmlAttribute(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    HtmlAttribute.create = function (value0) {
        return function (value1) {
            return new HtmlAttribute(value0, value1);
        };
    };
    return HtmlAttribute;
})();
var HtmlElement = (function () {
    function HtmlElement(value0) {
        this.value0 = value0;
    };
    HtmlElement.create = function (value0) {
        return new HtmlElement(value0);
    };
    return HtmlElement;
})();
var HtmlText = (function () {
    function HtmlText(value0) {
        this.value0 = value0;
    };
    HtmlText.create = function (value0) {
        return new HtmlText(value0);
    };
    return HtmlText;
})();
var HtmlComment = (function () {
    function HtmlComment(value0) {
        this.value0 = value0;
    };
    HtmlComment.create = function (value0) {
        return new HtmlComment(value0);
    };
    return HtmlComment;
})();
var textParser = Data_Functor.map(Text_Parsing_StringParser.functorParser)(function ($36) {
    return HtmlText.create($foreign.decodeHtmlEntity($36));
})(Text_Parsing_StringParser_CodeUnits.regex("[^<]+"));
var selfClosingTags = [ "br", "img", "hr", "meta", "input", "embed", "area", "base", "col", "keygen", "link", "param", "source", "command", "link", "track", "wbr" ];
var quotedString2 = Control_Apply.applyFirst(Text_Parsing_StringParser.applyParser)(Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(Text_Parsing_StringParser_CodeUnits.string("\""))(Text_Parsing_StringParser_CodeUnits.regex("[^\"]*")))(Text_Parsing_StringParser_CodeUnits.string("\""));
var quotedString1 = Control_Apply.applyFirst(Text_Parsing_StringParser.applyParser)(Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(Text_Parsing_StringParser_CodeUnits.string("'"))(Text_Parsing_StringParser_CodeUnits.regex("[^']*")))(Text_Parsing_StringParser_CodeUnits.string("'"));
var quotedString = Control_Alt.alt(Text_Parsing_StringParser.altParser)(quotedString1)(quotedString2);
var mkElement = function (v) {
    return function (v1) {
        return function (v2) {
            return {
                name: v,
                attributes: v1,
                children: v2
            };
        };
    };
};
var isSelfClosingElement = function (ele) {
    return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqString)(ele.name)(selfClosingTags);
};
var equals = Control_Apply.applyFirst(Text_Parsing_StringParser.applyParser)(Text_Parsing_StringParser_CodeUnits.string("="))(Text_Parsing_StringParser_CodeUnits.whiteSpace);
var eqHtmlAttribute = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x.value0 === y.value0 && x.value1 === y.value1;
    };
});
var eqHtmlNode = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof HtmlElement && y instanceof HtmlElement) {
            return Data_Eq.eq(Data_List_Types.eqList(eqHtmlAttribute))(x.value0.attributes)(y.value0.attributes) && Data_Eq.eq(Data_List_Types.eqList(eqHtmlNode))(x.value0.children)(y.value0.children) && x.value0.name === y.value0.name;
        };
        if (x instanceof HtmlText && y instanceof HtmlText) {
            return x.value0 === y.value0;
        };
        if (x instanceof HtmlComment && y instanceof HtmlComment) {
            return x.value0 === y.value0;
        };
        return false;
    };
});
var charListToString = (function () {
    var $37 = Data_Array.fromFoldable(Data_List_Types.foldableList);
    return function ($38) {
        return Data_String_CodeUnits.fromCharArray($37($38));
    };
})();
var commentParser = Control_Bind.discard(Control_Bind.discardUnit)(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.skipSpaces)(function () {
    return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(Text_Parsing_StringParser_CodeUnits.string("<!--"))(Text_Parsing_StringParser_Combinators.manyTill(Text_Parsing_StringParser_CodeUnits.anyChar)(Text_Parsing_StringParser_CodeUnits.string("-->"))))(function (comment) {
        return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(HtmlComment.create(charListToString(comment)));
    });
});
var attributeParser = Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.regex("[^=>/ ]+"))(function (k) {
    return Control_Bind.discard(Control_Bind.discardUnit)(Text_Parsing_StringParser.bindParser)(Data_Functor["void"](Text_Parsing_StringParser.functorParser)(Text_Parsing_StringParser_CodeUnits.whiteSpace))(function () {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_Combinators.option("")(Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(equals)(quotedString)))(function (v) {
            return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(new HtmlAttribute(k, v));
        });
    });
});
var openingParser = Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.string("<"))(function () {
    return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.regex("[^/>\x0a ]+"))(function (tagName) {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(Text_Parsing_StringParser_CodeUnits.whiteSpace)(Text_Parsing_StringParser_Combinators.sepEndBy(attributeParser)(Text_Parsing_StringParser_CodeUnits.whiteSpace)))(function (attributes) {
            return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(mkElement(tagName)(attributes)(Data_List_Types.Nil.value));
        });
    });
});
var nodeParser = Control_Lazy.defer(Text_Parsing_StringParser.lazyParser)(function (v) {
    return Control_Alt.alt(Text_Parsing_StringParser.altParser)(Control_Alt.alt(Text_Parsing_StringParser.altParser)(Text_Parsing_StringParser["try"](textParser))(Text_Parsing_StringParser["try"](commentParser)))(elementParser);
});
var elementParser = Control_Lazy.defer(Text_Parsing_StringParser.lazyParser)(function (v) {
    return Control_Bind.discard(Control_Bind.discardUnit)(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_CodeUnits.skipSpaces)(function () {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Control_Bind.bind(Text_Parsing_StringParser.bindParser)(openingParser)(closingOrChildrenParser))((function () {
            var $39 = Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser);
            return function ($40) {
                return $39(HtmlElement.create($40));
            };
        })());
    });
});
var closingOrChildrenParser = function (element) {
    var childrenParser = Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(Text_Parsing_StringParser_CodeUnits.whiteSpace)(Text_Parsing_StringParser_CodeUnits.string(">")))(function () {
        return Control_Bind.bind(Text_Parsing_StringParser.bindParser)(Text_Parsing_StringParser_Combinators.manyTill(nodeParser)(Text_Parsing_StringParser_CodeUnits.string("</" + (element.name + ">"))))(function (children) {
            return Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)({
                children: children,
                attributes: element.attributes,
                name: element.name
            });
        });
    });
    return Control_Lazy.defer(Text_Parsing_StringParser.lazyParser)(function (v) {
        var $35 = isSelfClosingElement(element);
        if ($35) {
            return Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(Control_Apply.applySecond(Text_Parsing_StringParser.applyParser)(Text_Parsing_StringParser_CodeUnits.whiteSpace)(Text_Parsing_StringParser_Combinators.optional(Text_Parsing_StringParser_CodeUnits.string("/"))))(Text_Parsing_StringParser_CodeUnits.string(">")))(Control_Applicative.pure(Text_Parsing_StringParser.applicativeParser)(element));
        };
        return childrenParser;
    });
};
var parse = function (input) {
    return Text_Parsing_StringParser.runParser(Text_Parsing_StringParser_Combinators.many(nodeParser))(input);
};
module.exports = {
    HtmlElement: HtmlElement,
    HtmlText: HtmlText,
    HtmlComment: HtmlComment,
    HtmlAttribute: HtmlAttribute,
    parse: parse,
    eqHtmlNode: eqHtmlNode,
    eqHtmlAttribute: eqHtmlAttribute
};
